// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1FBrm","header":"Messages_header__20J_E"};